import { SHARED_FILTERS } from './send-mail-stepper-shared-filters';

export const SEND_MAIL_STEPPER_FORWARD_OWN_FILTERS = {
  path: '/mailing/stepper/forward-own/:id',
  filters: SHARED_FILTERS
};